if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

/* ------------------------------------------------------------------
   Saint Lior – suporte a produtos com mais de 250 variantes.
   O tema só recebe as 250 primeiras variantes na página. Quando a
   combinação escolhida não está nessa lista, perguntamos à Shopify
   (seção "variant-resolver" + option_values) e seguimos o fluxo normal.
------------------------------------------------------------------- */
(function () {
  var LIMIT = 250;
  var RESOLVER = 'variant-resolver';

  function isMainPicker(el) {
    return !el.querySelector('select[name="id"]');
  }

  function isTruncated(el) {
    if (!isMainPicker(el)) return false;
    try {
      return el.getVariantData().length >= LIMIT;
    } catch (e) {
      return false;
    }
  }

  function fetchResolver(el, query) {
    var base = el.dataset.url;
    var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + RESOLVER + (query ? '&' + query : '');
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var node = doc.querySelector('[data-variant-resolver]');
        return node ? JSON.parse(node.textContent) : null;
      });
  }

  function sameOptions(variant, options) {
    if (!variant || !variant.options || !options) return false;
    if (variant.options.length !== options.length) return false;
    for (var i = 0; i < options.length; i++) if (variant.options[i] !== options[i]) return false;
    return true;
  }

  function applyStatuses(el, options) {
    if (!options) return;
    var wrappers = Array.prototype.slice.call(el.querySelectorAll('.product-form__input'));
    if (!wrappers.length) wrappers = Array.prototype.slice.call(el.querySelectorAll('fieldset'));
    options.forEach(function (option, i) {
      var wrapper = wrappers[i];
      if (!wrapper) return;
      var inputs = Array.prototype.slice.call(wrapper.querySelectorAll('input[type="radio"], option'));
      var available = option.values.filter(function (v) { return v.available; }).map(function (v) { return v.name; });
      el.setInputAvailability(inputs, available);
    });
  }

  function resolve(el, statusesOnly) {
    var token = (el.__slToken = (el.__slToken || 0) + 1);
    var selected = (el.options || []).slice();
    var mapPromise = el.__slMap ? Promise.resolve(el.__slMap) : fetchResolver(el).then(function (d) {
      el.__slMap = d ? d.options : null;
      return el.__slMap;
    });

    return mapPromise
      .then(function (map) {
        if (!map) return null;
        var ids = selected.map(function (name, i) {
          var opt = map[i];
          var val = opt && opt.values.filter(function (v) { return v.name === name; })[0];
          return val ? val.id : null;
        });
        if (ids.some(function (id) { return !id; })) return null;
        return fetchResolver(el, 'option_values=' + ids.join(','));
      })
      .then(function (data) {
        if (token !== el.__slToken) return; // o cliente já clicou em outra opção
        el.__slResolving = false;
        if (data) applyStatuses(el, data.options);
        if (statusesOnly) return;

        var variant = null;
        if (data && sameOptions(data.selected, selected)) variant = data.selected;
        else if (data && sameOptions(data.selectedOrFirst, selected)) variant = data.selectedOrFirst;

        if (!variant) {
          el.toggleAddButton(true, '', true);
          el.setUnavailable();
          return;
        }

        var list = el.getVariantData();
        if (!list.some(function (v) { return v.id === variant.id; })) list.push(variant);

        if (el.currentVariant && el.currentVariant.id === variant.id) return; // já estava certo
        el.currentVariant = variant;
        el.updatePickupAvailability();
        el.removeErrorMessage();
        el.updateMedia();
        el.updateURL();
        el.updateVariantInput();
        el.renderProductInfo();
        el.updateShareUrl();
      })
      .catch(function () {
        if (token !== el.__slToken) return;
        el.__slResolving = false;
        if (!statusesOnly && !el.currentVariant) {
          el.toggleAddButton(true, '', true);
          el.setUnavailable();
        }
      });
  }

  function patch() {
    var VS = customElements.get('variant-selects');
    if (!VS) return false;
    var proto = VS.prototype;
    if (proto.__slHighVariants) return true;
    proto.__slHighVariants = true;

    // Correção: estas funções só existiam no seletor em botões e quebravam o seletor em lista.
    var VR = customElements.get('variant-radios');
    if (VR) {
      if (!proto.updateStickyATC && VR.prototype.updateStickyATC) proto.updateStickyATC = VR.prototype.updateStickyATC;
      if (!proto.updateQtyBreak && VR.prototype.updateQtyBreak) proto.updateQtyBreak = VR.prototype.updateQtyBreak;
    }
    if (!proto.updateStickyATC) proto.updateStickyATC = function () {};
    if (!proto.updateQtyBreak) proto.updateQtyBreak = function () {};

    var originalUpdateMasterId = proto.updateMasterId;
    proto.updateMasterId = function () {
      originalUpdateMasterId.call(this);
      if (!isTruncated(this)) return;
      this.__slResolving = !this.currentVariant;
      resolve(this, false);
    };

    var originalStatuses = proto.updateVariantStatuses;
    proto.updateVariantStatuses = function () {
      if (isTruncated(this)) return; // a disponibilidade vem da Shopify em resolve()
      return originalStatuses.apply(this, arguments);
    };

    var originalUnavailable = proto.setUnavailable;
    proto.setUnavailable = function () {
      if (this.__slResolving) return; // ainda consultando a Shopify
      return originalUnavailable.apply(this, arguments);
    };

    // Ao abrir a página, corrige a marcação de esgotado das opções.
    document.querySelectorAll('variant-radios, variant-selects').forEach(function (el) {
      if (el.__slInit || !isTruncated(el)) return;
      el.__slInit = true;
      el.updateOptions();
      resolve(el, true);
    });
    return true;
  }

  if (!patch()) document.addEventListener('DOMContentLoaded', patch);
})();
